import { Component, OnInit } from '@angular/core';
import {DataService} from "../shared/data.service";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  locale = 'en';
  currentYear = new Date().getFullYear();

  constructor(
    private service: DataService
  ) { }

  ngOnInit(): void {
    this.getLocale();
  }

  getLocale() {
    this.locale = this.service.lang;
  }

  setLocale(locale) {
    if (locale == 'hu' || locale == 'en') {
      this.service.setLocale(locale);
      this.locale = locale;
      location.reload();
    }
  }
}
